<template>
  <div>
    <sidebar-release
      :items="releases"
      :loader="loader"
      :toggleSidebarReleases="visibleSideBarReleases"
      @closeSidebarReleases="closeSidebarReleases"
    />
    <base-nav
      container-classes="container-fluid prl-30"
      class="navbar-top navbar-expand"
      :class="$route.meta.navbarClasses ? $route.meta.navbarClasses : ''"
      :itemsBread="itemsBread"
      :logo="getLogo()"
      app="SUPPLIERS"
    >
      <ul class="navbar-nav align-items-center ml-md-auto"></ul>
      <ul class="navbar-nav align-items-center ml-auto ml-md-0">
        <base-button
          type="outline-neutral"
          class="button-wn"
          @click="openSideBarReleases"
        >
          <i class="flaticon-history-1"></i> What's new
          <span v-if="latestNewsAvailable" class="point-status danger"></span>
        </base-button>

        <base-dropdown
          menu-on-right
          class="nav-item"
          tag="li"
          title-tag="a"
          title-classes="nav-link pr-0"
        >
          <a
            href="#"
            class="nav-link pr-0"
            @click.prevent
            slot="title-container"
          >
            <div class="media align-items-center">
              <span class="img-profile">
                <div
                  class="img-user-list"
                  v-bind:style="{
                    backgroundImage: profile.url_picture
                      ? `url('${profile.url_picture}')`
                      : `url('${imageProfile}')`
                  }"
                ></div>
              </span>
              <div class="media-body ml-1 d-none d-lg-block">
                <span class="link-drop capitalize"
                  >{{ profile.first_name }} {{ profile.last_name }}</span
                >
              </div>
            </div>
          </a>

          <template>
            <div class="dropdown-header noti-title">
              <h6 class="text-overflow m-0">Welcome!</h6>
              <span class="capitalize no-desk"
                >{{ profile.first_name }} {{ profile.last_name }}</span
              >
            </div>
            <router-link to="/my-profile" class="dropdown-item">
              <i class="flaticon-profile"></i>
              <span>My profile</span>
            </router-link>

            <router-link
              to="/settings"
              class="dropdown-item"
              v-if="
                sesion.role === 'supplier' &&
                  (sesion.account_type.type === 'supplier_access' ||
                    sesion.account_type.type === 'supplier')
              "
            >
              <i class="flaticon-settings"></i>
              <span>Settings</span>
            </router-link>
            <div class="dropdown-divider"></div>

            <router-link to="/help" target="_blank" class="dropdown-item">
              <i class="flaticon-question"></i>
              <span>Help</span>
            </router-link>

            <span
              class="dropdown-item d-xl-none d-lg-none d-md-none d-sm-block d-block"
              @click="openSideBarReleases"
            >
              <i class="flaticon-history-1"></i>
              <span>What's new</span>
              <span v-if="latestNewsAvailable" class="point-status danger">
              </span>
            </span>

            <span class="dropdown-item" @click="about = true">
              <i class="flaticon-warning"></i>
              <span>About RhomTrip</span>
            </span>
            <div class="dropdown-divider"></div>
            <a href="javascript:;" @click="logout" class="dropdown-item">
              <i class="ni ni-user-run"></i>
              <span>Logout</span>
            </a>
          </template>
        </base-dropdown>
        <li class="nav-item d-lg-none ml-3">
          <!-- Sidenav toggler -->
          <div
            class="sidenav-toggler"
            :class="{
              active: $sidebar.showSidebar,
              'sidenav-toggler-light': type === 'light'
            }"
            @click="toggleSidebar"
          >
            <div class="sidenav-toggler-inner">
              <i class="sidenav-toggler-line"></i>
              <i class="sidenav-toggler-line"></i>
              <i class="sidenav-toggler-line"></i>
            </div>
          </div>
        </li>
      </ul>
    </base-nav>

    <modal :show.sync="about">
      <template slot="header">
        <h5 class="subtitle mb-3" id="exampleModalLabel">About RhomTrip</h5>
      </template>
      <div class="col-12">
        <img
          src="~rhomtrip_assets/src/img/brand/logo-rhomtrip-mobility-suppliers.png"
          alt="RhomTrip"
          class="logo-min-about mt-4"
        />

        <div class="text-center">
          <p class="text-black mb-0">
            Version {{ systemInfo.release.version }}
          </p>
          <p class="upper font-weight-700">Enterprise Edition</p>
        </div>

        <div class="border-top pt-3 pb-0">
          <p class="text-center lh-140">
            The all-in-one tool, RhomTrip Mobility, is a cloud-based solution
            that caters to the needs of small and medium-sized suppliers, as
            well as a wide range of travel partners including Agents, Agencies,
            and suppliers.
          </p>
        </div>

        <div class="row border-top pt-1 pb-1">
          <div class="row justify-content-center">
            <div
              class="col-xl-3 col-lg-6 col-md-3 col-sm-3 col-3 align-self-center"
            >
              <a href="https://www.iata.org" target="_blank">
                <img
                  class="img-fluid"
                  src="~rhomtrip_assets/src/img/partnership/iata-rhomtrip.png"
                  alt="iata-code"
              /></a>
            </div>
            <div
              class="col-xl-3 col-lg-6 col-md-3 col-sm-3 col-3 align-self-center"
            >
              <a href="https://www.asta.org/" target="_blank">
                <img
                  class="img-fluid"
                  src="~rhomtrip_assets/src/img/partnership/asta-travel-advisors.png"
                  alt="asta"
              /></a>
            </div>
            <div
              class="col-xl-3 col-lg-6 col-md-3 col-sm-3 col-3 align-self-center"
            >
              <a href="https://www.octo.travel" target="_blank">
                <img
                  class="img-fluid"
                  src="~rhomtrip_assets/src/img/partnership/octo-travel.png"
                  alt="octo"
              /></a>
            </div>
            <div
              class="col-xl-3 col-lg-6 col-md-3 col-sm-3 col-3 align-self-center"
            >
              <a href="https://www.tripadvisor.com" target="_blank">
                <img
                  class="img-fluid"
                  src="~rhomtrip_assets/src/img/partnership/tripadvisor-2023.png"
                  alt="tripadvisor"
              /></a>
            </div>
          </div>
        </div>
      </div>
      <div class="border-top pt-3 text-center col-12">
        <div class="d-block">
          <a
            href="https://rhomtrip.com/terms-conditions/"
            class="text-sm"
            target="_blank"
            >Terms and conditions
          </a>
          |
          <a
            href="https://rhomtrip.com/privacy-policy/"
            class="text-sm"
            target="_blank"
            >Privacy Policy
          </a>
          |
          <a
            href="https://rhomtrip.com/contact/"
            class="text-sm"
            target="_blank"
            >Contact us
          </a>
        </div>

        © {{ systemInfo.year }} RhomTrip OÜ™. All Rights Reserved.
      </div>
    </modal>
  </div>
</template>

<script>
import "../../scss/styles.scss";
import { mapGetters, mapActions, mapMutations } from "vuex";
import { CollapseTransition } from "vue2-transitions";
import flatPicker from "vue-flatpickr-component";
import Swal from "sweetalert2";
import endpoint from "../Commons/Services/index";
import "flatpickr/dist/flatpickr.css";
import WSelect from "@/components/Select";

WSelect.computed.readonly = function() {
  const isIE = !this.$isServer && !Number.isNaN(Number(document.documentMode));
  return (
    !this.filterable ||
    this.multiple ||
    (!isIE && !this.visible && !this.remote)
  );
};

/**
 * Dashboard Navigation Bar Component
 *
 * Manages the top navigation bar with user profile, notifications,
 * release notes, and session management functionality.
 *
 * @component
 * @example
 * <DashboardNavbar type="default" />
 */
export default {
  name: "DashboardNavbar",
  props: {
    /**
     * Visual style of the navbar
     * @type {String}
     * @default 'default'
     * @description Look of the dashboard navbar. Default (Green) or light (gray)
     */
    type: {
      type: String,
      default: "default",
      validator: value => ["default", "light"].includes(value),
      description:
        "Look of the dashboard navbar. Default (Green) or light (gray)"
    }
  },
  data() {
    return {
      about: false,
      imageProfile: require("rhomtrip_assets/src/img/users/user-placeholder.png"),
      visibleSideBarReleases: false,
      releases: [],
      loader: false
    };
  },
  watch: {
    /*********** Session Watchers ***********/
    sigout: {
      handler: function(current, old) {
        if (current.length > 0) {
          this.sesionFinish();
        }
      }
    }
  },
  async created() {
    this.getSesion();
    if (this.sesion) {
      this.getBranchesOptionsByOperatorId(this.sesion.account_type.owner);
    }
  },
  methods: {
    /**
     * Logs out the current user and cleans up application state
     * Clears local storage, resets store values, and redirects to sign in
     */
    logout() {
      localStorage.removeItem("es-login");
      this.setResponseReservations({});
      this.setDrivers({});
      this.setOperatorRespose({});
      this.setResponseBranch({});
      this.setResponseArea({});
      this.setVehicles({});
      this.$router.push({ path: "/signin" });
    },
    /**
     * Toggles the main sidebar visibility
     */
    toggleSidebar() {
      this.$sidebar.displaySidebar(!this.$sidebar.showSidebar);
    },
    /**
     * Handles session expiration with user confirmation
     * Shows a modal to inform the user about session expiration
     */
    async sesionFinish() {
      const { value } = await Swal.fire({
        title: "Your session has expired",
        html:
          "For you security your current session has expired and you have been logged out.",
        imageUrl: require("rhomtrip_assets/src/img/icons/alerts/warning.png"),
        buttonsStyling: false,
        showCloseButton: false,
        showCancelButton: false,
        focusConfirm: true,
        reverseButtons: true,
        allowOutsideClick: false,
        allowEscapeKey: false,
        cancelButtonText: "",
        cancelButtonClass: "btn btn-link",
        confirmButtonText: "Accept",
        confirmButtonClass: "btn btn-primary btn-small"
      });

      if (value) {
        this.logout();
      }
    },
    /**
     * Get logo of the company
     */
    getLogo() {
      if (this.settings) {
        if (this.settings.permissions.brand) {
          return this.settings.brand.logos.default
            ? this.settings.brand.logos.default
            : require("rhomtrip_assets/src/img/brand/logo-rhomtrip-mobility-suppliers.png");
        }
      }
      return require("rhomtrip_assets/src/img/brand/logo-rhomtrip-mobility-suppliers.png");
    },
    /**
     * Opens the release notes sidebar
     * Fetches latest releases and marks them as viewed if there are new ones
     */
    async openSideBarReleases() {
      this.visibleSideBarReleases = true;
      this.loader = true;
      this.releases = await this.getReleasesByApp("SUPPLIERS");
      this.loader = false;
      if (this.latestNewsAvailable) {
        let latestNewsAvailable = await this.markReleaseAsWatched(
          "SUPPLIERS",
          this.systemInfo.release.version,
          {
            user: {
              type: "Suppliers",
              ref: this.sesion.id
            },
            hasViewed: true
          }
        );
        this.setLatestNewsAvailable(latestNewsAvailable);
      }
    },
    /**
     * Closes the release notes sidebar
     * @param {boolean} status - New visibility status
     */
    closeSidebarReleases(status) {
      this.visibleSideBarReleases = status;
    },
    /**
     * Fetches release notes for a specific application
     * @param {string} app - Application identifier (e.g., 'INTERNAL')
     * @returns {Promise<Array>} Array of release notes or empty array on error
     */
    async getReleasesByApp(app) {
      try {
        let { data } = await endpoint.documents.services.getReleasesByApp(
          app,
          this.sesion.token
        );
        if (data.status) {
          return data.data;
        }
        return [];
      } catch (error) {
        return [];
      }
    },
    /**
     * Marks a specific release as watched by the current user
     * @param {string} app - Application identifier
     * @param {string} releaseVersion - Version of the release
     * @param {Object} payload - User information and viewed status
     * @returns {Promise<boolean>} Returns false if successfully marked, true otherwise
     */
    async markReleaseAsWatched(app, releaseVersion, payload) {
      try {
        let { data } = await endpoint.documents.services.markReleaseAsWatched(
          app,
          releaseVersion,
          payload,
          this.sesion.token
        );
        if (data.status) {
          return false;
        }
        return true;
      } catch (error) {
        return true;
      }
    },
    /**
     * Vuex Mappings
     * @description Mappings for Vuex actions to dispatch store actions
     */
    ...mapActions(["getBranchesOptionsByOperatorId", "getSesion"]),
    /**
     * Vuex Mutations
     * @description Mappings for Vuex mutations to update the store state
     */
    ...mapMutations([
      "setResponseReservations",
      "setProfile",
      "setDrivers",
      "setOperatorRespose",
      "setResponseArea",
      "setResponseBranch",
      "setVehicles",
      "setLatestNewsAvailable"
    ])
  },
  computed: {
    /*
     * Vuex Getters
     * @description Mappings for Vuex getters to access store state
     */
    ...mapGetters([
      "load",
      "sesion",
      "profile",
      "sigout",
      "settings",
      "itemsBread",
      "systemInfo",
      "latestNewsAvailable"
    ])
  },
  components: {
    CollapseTransition,
    flatPicker,
    WSelect
  }
};
</script>
